import React from "react";

export const About = ({ data, section }) => {
  const s = section || {};
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <img src="img/about.jpg" className="img-responsive" alt="CocoAutomation team" />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>{s.heading || "About Us"}</h2>
              <p>{data ? data.paragraph : ""}</p>
              <h3>{s.why_heading || "Why Choose Us?"}</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {data ? data.Why.map((d, i) => <li key={`${d}-${i}`}>{d}</li>) : null}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {data ? data.Why2.map((d, i) => <li key={`${d}-${i}`}>{d}</li>) : null}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
